const defaultState = {
  overlayVisible: false,
  editing: false,
  buttonsDisabled: false,
  workflowOptions: []
};
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'TOGGLE_OVERLAY_VISIBLE':
      return {
        ...state,
        overlayVisible: !state.overlayVisible
      };
    case 'SET_PROFILE':
      return {
        ...state,
        objData: action.objData
      };
    case 'CLEAR_PROFILE':
      return defaultState
    case 'SET_CHANGES':
      return {
        ...state,
        changes: action.changes
      };
    case 'CLEAR_CHANGES':
      return {
        ...state,
        changes: []
      };
    case 'SET_EDITING':
      return {
        ...state,
        editing: action.editing
      };
    case 'SET_BUTTONS_DISABLED':
      return {
        ...state,
        buttonsDisabled: action.buttonsDisabled
      };
    case 'UPDATE_PROFILE_CHANGES':
      const newProfile = { ...state.objData };
      const newChanges = [...state.changes];
      for (const [key, value] of Object.entries(action.newProfileData)) {
        if (key.indexOf('preferred') === 0) {
          const newKey = key.replace('preferred_', '');
          const splitKey = newKey.split('_');
          const finalKey = splitKey.includes('name') ?
            'preferred' + splitKey[0].charAt(0).toUpperCase() + splitKey[0].slice(1) + splitKey[1][0].toUpperCase() + splitKey[1].substring(1)
            :
            splitKey[0] + splitKey[1][0].toUpperCase() + splitKey[1].substring(1);
          newProfile[finalKey] = value
        } else {
          newProfile[key] = value;
        }
        newChanges.push(key);
      }
      return {
        ...state,
        objData: newProfile,
        changes: newChanges
      }
    case 'SET_WORKFLOW_OPTIONS':
      return {
        ...state,
        workflowOptions: action.workflowOptions
      };
    case 'SET_CHECKED_OUT_INFO':
      return {
        ...state,
        objData: {
          ...state.objData,
          checkedOutByEmail: action.checkedOutByEmail,
          checkedOutByName: action.checkedOutByName
        }
      };
    case 'SET_SUBMITTED_INFO':
      return {
        ...state,
        objData: {
          ...state.objData,
          submittedByEmail: action.submittedByEmail,
          submittedByName: action.submittedByName
        }
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/profileReducer.jsx